module.exports = __webpack_public_path__ + "static/media/icon-winner.7483fed3.png";